import { useRef } from 'react'
import EqualityHashMap, { EqualityHashMapKey } from './EqualityHashMap'

const useStableEqualityHashMap = <K extends EqualityHashMapKey, V>(map: ReadonlyMap<K, V>): ReadonlyMap<K, V> => {
  const ref = useRef(map)
  if (
    map !== ref.current &&
    !(map instanceof EqualityHashMap && ref.current instanceof EqualityHashMap && map.equals(ref.current))
  )
    ref.current = map
  return ref.current
}

export default useStableEqualityHashMap
